<script>
import Layout from '@/router/layouts/main.vue'

export default {
  name: 'CandidateForms',

  components: {
    Layout,
  },

  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'Candidate Forms page.' }],
    }
  },
}
</script>

<template>
  <Layout>
    <router-view />
  </Layout>
</template>
